import { z } from 'zod';
import { email as emailSchema } from './common.js';
/** Versão dos Termos de uso e da Política de privacidade aceitos no cadastro (landing /termos/ e /privacidade/). */
export const TERMS_VERSION = '2026-10';
/** Cadastro pelo site (roadmap §3): formulário → código por e-mail → negócio criado e sessão aberta. */
export const signupStartSchema = z.object({
    planId: z.string().uuid(),
    businessName: z.string().trim().min(2).max(120),
    segment: z.string().trim().max(80).nullable().optional(),
    name: z.string().trim().min(2).max(120),
    email: emailSchema,
    phone: z.string().trim().min(8).max(32),
    password: z.string().min(8).max(200),
    timezone: z.string().min(3).max(64).default('America/Sao_Paulo'),
    locale: z.enum(['pt-BR', 'en-US']).default('pt-BR'),
    acceptTerms: z.literal(true),
    turnstileToken: z.string().max(4096).optional(),
    ref: z.string().max(400).optional().describe('token do link entregue pela Lia do Koyomi'),
    utm: z.record(z.string(), z.string().max(200)).optional(),
});
export const signupConfirmSchema = z.object({ requestId: z.string().uuid(), code: z.string().trim().regex(/^\d{6}$/) });
export const signupResendSchema = z.object({ requestId: z.string().uuid() });
//# sourceMappingURL=signup.js.map